const TierSummary = ({ tier }) => (
    <div className="md:sticky md:top-28">
        <div className="relative">
            <div className="absolute -inset-3 border border-border" aria-hidden />
            <div className="relative bg-card p-8 md:p-10">
                <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                    Your Slate
                </p>
                <p className="mt-4 font-serif text-3xl font-medium tracking-tight">
                    {tier.name}
                </p>
                <p className="mt-1 text-sm text-muted-foreground">{tier.tagline}</p>
                <p className="mt-8 font-serif text-5xl font-medium tracking-tight">
                    {tier.priceLabel}
                </p>
                <ul className="mt-8 space-y-3 text-sm">
                    {tier.deliverables.map((d) => (
                        <li key={d} className="flex items-start gap-3">
                            <span aria-hidden className="mt-1.5 inline-block h-[2px] w-3 shrink-0 bg-foreground/60" />
                            <span>{d}</span>
                        </li>
                    ))}
                </ul>
                <p className="mt-10 border-t border-border pt-6 text-xs text-muted-foreground">
                    No payment today. We&apos;ll send a secure link after we review your intake — usually within one business day.
                </p>
            </div>
        </div>
    </div>
);

export default TierSummary;
